import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import Sidebar from "../Components/Sidebar";
import excel from "../assests/images/excel img.png";
import { Link } from "react-router-dom";
import CreateCoupon from "./CreateCoupon";
import Constant from "../Components/Utils/Constant";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditCouponForm from "../Components/models/EditCouponForm";
import { useSelector } from "react-redux";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

export default function SubscriotionCuppon501() {
    const [showCreatecouponForm, setshowCreatecouponForm] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [showActiveConfirmation, setShowActiveConfirmation] = useState(false);
    const [loading, setLoading] = useState(true);
    const tableRef = React.createRef();
    const [editPopup, setEditPopup] = useState(false);
    const [subscription, setSubscription] = useState([]);
    const [cuponToDelete, setCuponToDelete] = useState(null);
    const [couponToToggleStatus, setCouponToToggleStatus] = useState(null);
    const highlightedId = useSelector((state) => state.DataReducer.highlightedId);

    // State for frontend logic
    const [allCoupons, setAllCoupons] = useState([]);
    const [displayedCoupons, setDisplayedCoupons] = useState([]);
    const [filterStatus, setFilterStatus] = useState("");
    const [sortOrder, setSortOrder] = useState("");

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const ITEMS_PER_PAGE = 15;

    const fetchAllData = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            const role = localStorage.getItem("role");
            // Fetch Coupons
            const couponResponse = await fetch(`${Constant.BASE_URL}/cupon/getCuponAccess`, {
                headers: { Authorization: `Bearer ${token}`, Role: role },
            });
            const couponData = await couponResponse.json();
            if (couponData && Array.isArray(couponData.cupon)) {
                setAllCoupons(couponData.cupon);
            }

            // Fetch Subscriptions
            const subResponse = await fetch(`${Constant.BASE_URL}/subscription/getSubscriptionAccess`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            const subData = await subResponse.json();
            if (subData && subData.subscription) {
                setSubscription(subData.subscription);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllData();
    }, [showCreatecouponForm]);

    // Frontend filtering and sorting
    useEffect(() => {
        let processedCoupons = [...allCoupons];

        // 1. FIXED FILTER LOGIC TO INCLUDE 'EXPIRED'
        if (filterStatus) {
            processedCoupons = processedCoupons.filter(coupon => {
                if (filterStatus === 'active') {
                    return coupon.active === false;
                }
                if (filterStatus === 'blocked') {
                    return coupon.active === true;
                }
                if (filterStatus === 'expired') {
                    // This requires a `createdAt` field from your API
                    if (!coupon.createdAt || isNaN(Number(coupon.validdays))) {
                        return false; // Cannot determine expiry, so don't show it
                    }
                    const creationDate = new Date(coupon.createdAt);
                    const validDays = Number(coupon.validdays);
                    const expiryDate = new Date(creationDate);
                    expiryDate.setDate(expiryDate.getDate() + validDays);
                    return expiryDate < new Date(); // Return true if expiry date is in the past
                }
                return true;
            });
        }

        if (sortOrder) {
            processedCoupons.sort((a, b) => {
                const aDays = Number(a.validdays) || 0;
                const bDays = Number(b.validdays) || 0;
                return sortOrder === 'asc' ? aDays - bDays : bDays - aDays;
            });
        }

        setDisplayedCoupons(processedCoupons);
        setCurrentPage(1); // Reset page on filter/sort
    }, [allCoupons, filterStatus, sortOrder]);

    // Pagination Logic
    const pageCount = Math.ceil(displayedCoupons.length / ITEMS_PER_PAGE);
    const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
    const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
    const currentItems = displayedCoupons.slice(indexOfFirstItem, indexOfLastItem);
    
    const handlePageClick = ({ selected }) => {
        setCurrentPage(selected + 1);
    };
    
    const handleOptionChange = (event, coupon) => {
        const selectedValue = event.target.value;
        if (selectedValue === "Edit") setEditPopup(coupon);
        else if (selectedValue === "Delete") handleOpenDeleteConfirmation(coupon._id);
        else if (selectedValue === "toggleStatus") handleToggleConfirmation(coupon);
        event.target.value = "";
    };

    const handleToggleConfirmation = (coupon) => {
        setCouponToToggleStatus(coupon);
        setShowActiveConfirmation(true);
    };

    const handleConfirmToggle = async () => {
        if (!couponToToggleStatus) return;
        const newStatus = !couponToToggleStatus.active;
        try {
            await axios.put(
                `${Constant.BASE_URL}/cupon/update/${couponToToggleStatus._id}`, { active: newStatus }
            );
            toast.success(`Coupon status updated successfully!`);
            setAllCoupons(allCoupons.map(c =>
                c._id === couponToToggleStatus._id ? { ...c, active: newStatus } : c
            ));
        } catch (error) {
            toast.error("Failed to update status.");
        } finally {
            setShowActiveConfirmation(false);
            setCouponToToggleStatus(null);
        }
    };

    const handleOpenDeleteConfirmation = (id) => {
        setCuponToDelete(id);
        setShowDeleteConfirmation(true);
    };

    const handleDelete = async () => {
        if (!cuponToDelete) return;
        try {
            await axios.delete(`${Constant.BASE_URL}/cupon/delete/${cuponToDelete}`);
            toast.success("Coupon deleted successfully");
            setAllCoupons(allCoupons.filter(c => c._id !== cuponToDelete));
        } catch (error) {
            toast.error("Failed to delete coupon.");
        } finally {
            setShowDeleteConfirmation(false);
            setCuponToDelete(null);
        }
    };
    
    const handleSort = () => {
        setSortOrder(current => (current === 'asc' ? 'desc' : 'asc'));
    };

    const handleExportToExcel = () => {
        if (tableRef.current) {
            const ws = XLSX.utils.table_to_sheet(tableRef.current);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Coupons");
            XLSX.writeFile(wb, "coupons.xlsx");
        }
    };

    return (
        <Sidebar>
            <>
                <ToastContainer position="top-right" autoClose={3000} />
                <div className="p-3 bg-grey-300 lg:p-3 xl:p-3 2xl:p-6">
                    <div className="bg-white h-[78.55vh]" style={{ borderRadius: "0px 0px 11px 11px" }}>
                        <div className="flex items-center px-4 py-3 bg-white lg:py-2 xl:py-3 2xl:py-3">
                            {/* Left Section */}
                            <div className="flex-1">
                                <div className="flex">
                                    <Link to="/subscription">
                                        <div style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }} className="lg:w-fit px-2 2xl:px-3 lg:py-1 xl:py-2 2xl:py-3 cursor-pointer flex justify-center items-center bg-white rounded-sm border">
                                            <p className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold">Subscription Plans: {subscription.length}</p>
                                        </div>
                                    </Link>
                                    <div style={{ background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)" }} className="flex items-center justify-center px-2 ml-3 bg-white rounded-sm cursor-pointer lg:w-fit 2xl:px-3 lg:py-1 xl:py-2 2xl:py-3">
                                        <p className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold">Coupons : {allCoupons.length}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Center Section - Filter */}
                            <div className="flex justify-center flex-1">
                                <div style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}>
                                    
                                </div>
                            </div>

                            {/* Right Section */}
                            <div className="flex-1">
                                <div className="flex items-center justify-end">
                                    <div className="mx-5">
                                        <img onClick={handleExportToExcel} src={excel} alt="excel" className="w-10 cursor-pointer 2xl:w-[80px] lg:w-[25px] xl:w-[35px]"/>
                                    </div>
                                    <div 
                                        onClick={() => setshowCreatecouponForm(true)} 
                                        style={{ background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)" }} 
                                        className="lg:w-fit px-4 2xl:px-6 py-2 cursor-pointer flex justify-center items-center bg-white rounded-md border"
                                        >
                                        <p className="text-5lg lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold">
                                            Create Coupon
                                        </p>
                                        </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full">
                            <div className="relative overflow-y-auto tablebodydata lg:h-[65vh] xl:h-[64vh] 2xl:h-[67vh]">
                                <table ref={tableRef} className="w-full text-center table-hover table-bordered" id="myTable">
                                    <thead className="sticky top-0 bg-gray-100">
                                        <tr>
                                            <th>Action</th>
                                            <th>Coupon Event</th>
                                            <th>Code</th>
                                            <th>Discount</th>
                                            <th>
                                                <button onClick={handleSort} className="flex items-center justify-center w-full">
                                                    Valid Days
                                                    <span className="ml-2">{sortOrder === 'asc' ? <FaSortUp /> : sortOrder === 'desc' ? <FaSortDown /> : <FaSort />}</span>
                                                </button>
                                            </th>
                                            <th>Users Assigned</th>
                                            {/* 2. FIXED: REMOVED a filter from header */}
                                            <th><select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)} className="lg:w-[100px] xl:w-[120px] 2xl:w-[210px] py-2 px-2 text-center outline-none border rounded-sm">
                                        <option value="">All Statuses</option>
                                        <option value="active">Active</option>
                                        <option value="blocked">Blocked</option>
                                    
                                    </select></th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">
                                        {currentItems.map((item, index) => (
                                            <tr key={item._id} className={index % 2 === 0 ? "bg-white" : "bg-gray-100"} style={{ backgroundColor: highlightedId === item._id ? "yellow" : "" }}>
                                                <td>
                                                    <div className="flex items-center justify-center">
                                                        <select onChange={(e) => handleOptionChange(e, item)} defaultValue="" className="lg:w-[67px] xl:w-[78px] 2xl:w-[120px] 2xl:text-xl py-1 text-center outline-none border rounded-md bg-white shadow-sm">
                                                            <option value="" disabled>Select</option>
                                                            <option value="Edit">Edit</option>
                                                            <option value="Delete">Delete</option>
                                                            <option value="toggleStatus">{item.active ? "Activate" : "Block"}</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td>{item.cuponevent}</td>
                                                <td>{item.cuponcode}</td>
                                                <td>{item.cupondiscount}</td>
                                                <td>{item.validdays}</td>
                                                <td>{item.cuponassign.join(", ")}</td>
                                                <td>
                                                    <span className={item.active ? "text-red-600 font-semibold" : "text-green-600 font-semibold"}>
                                                        {item.active ? "Blocked" : "Active"}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modals and Pagination */}
                <div className="flex lg:px-4">
                    <div className="w-full flex bg-white shadow-md">
                        <div className="w-full flex items-center fixed lg:bottom-5 xl:bottom-6 2xl:bottom-6 border-t lg:text-[10px] xl:text-[14px] 2xl:text-3xl lg:pt-1 xl:pt-1 2xl:pt-0">
                            <div className="flex justify-start w-full xl:px-5 2xl:p-5">
                                <p>Showing <span className="text-blue-500">{displayedCoupons.length > 0 ? indexOfFirstItem + 1 : 0}</span> to <span className="text-blue-500">{Math.min(indexOfLastItem, displayedCoupons.length)}</span> of <span className="text-yellow-500">{displayedCoupons.length}</span> entries</p>
                            </div>
                            <div className="flex justify-end pr-2 text-blue-500 pagination xl:pr-5">
                                <ReactPaginate previousLabel={"<"} nextLabel={">"} breakLabel={"..."} pageCount={pageCount} marginPagesDisplayed={1} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination flex items-center"} activeClassName={"active"} forcePage={currentPage - 1}/>
                            </div>
                        </div>
                    </div>
                </div>

                {showCreatecouponForm && <CreateCoupon onClose={() => setshowCreatecouponForm(false)} />}
                {editPopup && <EditCouponForm editPopup={editPopup} setEditPopup={setEditPopup} />}

                {showDeleteConfirmation && (
                    <div className="pop-delete">
                        <div className="flex items-center justify-center w-full">
                            <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md w-fit">
                                <div className="lg:w-[280px] xl:w-[280px] 2xl:w-[500px] items-center justify-center">
                                    <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl 2xl:py-3">Do you want to Delete?</div>
                                    <hr className="p-2 mt-1" />
                                    <div className="flex flex-col items-center justify-center py-5 2xl:text-[30px] 2xl:py-12">
                                        <button type="button" onClick={() => setShowDeleteConfirmation(false)} className="flex-shrink-0 w-16 bg-white shadow-md text rounded-sm 2xl:w-32" style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}>No</button>
                                        <button onClick={handleDelete} className="flex-shrink-0 w-16 mt-5 text-white bg-red-500 text rounded-sm 2xl:w-32">Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {showActiveConfirmation && (
                    <div className="pop-delete">
                        <div className="flex items-center justify-center w-full">
                            <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md w-fit">
                                <div className="lg:w-[280px] xl:w-[280px] 2xl:w-[500px] items-center justify-center">
                                    <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl 2xl:py-3">
                                        Do you want to {couponToToggleStatus?.active ? "Activate" : "Block"} this coupon?
                                    </div>
                                    <hr className="p-2 mt-1" />
                                    <div className="flex flex-col items-center justify-center py-5 lg:text-[10px] xl:text-[13px] 2xl:text-[30px] 2xl:py-12">
                                        <button type="button" onClick={() => setShowActiveConfirmation(false)} className="flex-shrink-0 py-1 bg-white shadow-md text px-7 rounded-sm 2xl:px-12" style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}>No</button>
                                        <button onClick={handleConfirmToggle} className="flex-shrink-0 py-1 mt-5 text-white bg-red-500 text px-7 rounded-sm 2xl:px-12">Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        </Sidebar>
    );
}